<template>
  <v-card class="my-3 mx-0" flat style="border: 1px solid rgba(0,0,0,0.13);">
    <v-toolbar light flat dense>
      <v-toolbar-title v-text="title" />
      <v-spacer />
      <v-dialog v-if="notEditable === false" v-model="dialog" max-width="400px">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>{{ icons.addContent }}</v-icon>
          </v-btn>
        </template>

        <assign-slide-dialog
          v-if="subslide"
          :parent-id="active._id"
          :title="`Add ${title}`"
          type="main"
          @close="dialog = false"
        />
        <add-group-slide-dialog
          v-else-if="slideType === 'popup'"
          :document-key="documentKey"
          :parent-id="active._id"
          :title="`Add ${title}`"
          :type="slideType"
          @close="dialog = false"
        />
        <child-slide-dialog
          v-else
          :parent-id="active._id"
          :document-key="documentKey"
          :title="`Add ${title}`"
          :type="slideType"
          @close="dialog = false"
        />
      </v-dialog>
    </v-toolbar>
    <v-container fluid grid-list-sm>
      <SortableList
        v-if="slides && slides.length > 0"
        v-model="slides"
        :axis="'xy'"
        :classes="'layout   wrap'"
        :press-delay="500"
        @sort-end="onSortEnd"
      >
        <SortableItem
          v-for="(slide, index) in slides"
          :key="slide._id"
          :classes="'xs6 sm6 md6 lg4 flex'"
          :index="index"
        >
          <main-card
            v-if="slide"
            :id="slide._id"
            dense
            :min-width="false"
            :preview="slide.asset.png"
            :status="slide.status"
            :will-delete="slide.deletion.willDelete"
            :has-popup="slide.popupSlides && slide.popupSlides.length > 0"
            :deletable="slideType !== 'animation'"
            :has-animation="slide.animationSlides && slide.animationSlides.length > 0"
            :has-reference="slide.references && slide.references.refs && slide.references.refs.length > 0"
            :subtitle="slide.externalId"
            :title="slide.name"
            @click.stop="setActive(slide._id)"
            @delete="deassignSubslide(index, slide)"
          />
          <router-link :to="`/database/slide/${slide._id}`" tag="div" />
        </SortableItem>
      </SortableList>
      <!-- TODO: Empty State -->
      <div v-if="slides && slides.length === 0">
        No slide assigned.
      </div>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import ChildSlideDialog from '@/components/dialogs/ChildSlideDialog';
import SortableItem from '@/components/hoc-dnd/SortableItem';
import SortableList from '@/components/hoc-dnd/SortableList';
import MainCard from '@/components/cards/main-card';
import {
  TOGGLE_DIALOG,
  TOGGLE_DIALOG_DOCUMENTS_CHOOSER,
  UPDATE_SORTED_SUBSLIDE_GROUP
} from '@/config/constants';
import AssignSlideDialog from '@/components/dialogs/AssignSlideDialog';
import AddGroupSlideDialog from '@/components/dialogs/AddGroupSlideDialog';
import { confirm } from '../../../utils/modal';
import AssetMixin from '@/mixins/AssetMixin';
import icons from '../../../mixins/icons';

export default {
  name: 'ChildSlidesContainer',
  components: {
    AddGroupSlideDialog,
    AssignSlideDialog,
    ChildSlideDialog,
    MainCard,
    SortableItem,
    SortableList
  },
  mixins: [AssetMixin, icons],
  props: {
    title: {
      type: String
    },
    documentKey: {
      type: String,
      required: true
    },
    sortable: {
      type: Boolean,
      default: false
    },
    slideType: String,
    notEditable: {
      type: Boolean,
      default: false
    },
    subslide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapState('slides', {
      active: state => state.active
    }),
    slides: {
      get() {
        return this.active[this.documentKey];
      },
      async set(array) {
        await this.$store.dispatch(UPDATE_SORTED_SUBSLIDE_GROUP, { array, key: this.documentKey });
      }
    }
  },
  methods: {
    setActive(id) {
      this.$router.push({ query: { ...this.$route.query, asset: id } });
      this.getData(id);
    },
    deassignSubslide(index, slide) {
      confirm('Deassign slide from group?', 'This can not be reverted.', 'Yes', 'No').then(yes => {
        if (yes) {
          this.slides.splice(index, 1);
          this.slides = this.slides;
        }
      });
    },
    onSortEnd(e) {
      // Handled by the setter of slides
    },
    async toggleDocumentsChooser() {
      await this.$store.dispatch(TOGGLE_DIALOG_DOCUMENTS_CHOOSER);
    },
    toggleDialog(item, type) {
      this.$store.commit(TOGGLE_DIALOG, item, type);
    }
  }
};
</script>

<style>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
  margin: 5px;
}

.sortable-list-container {
}
</style>
